export default __webpack_public_path__ + "static/media/Habit Plan.8a3fe0bb.pdf";